/**
 * roro-cart-bundle-discount — pega al carrito los códigos de descuento que le
 * correspondan. Desde el 2026-09-02 son DOS:
 *
 *   · el del par  (`cart_bundle_discount_code`, hoy RORO-PARA-5): Bxgy, por
 *     CANTIDAD de artículos, rebaja una sola línea — la más barata elegible.
 *   · el del set  (`gift_pack_discount_code`, hoy RORO-NABIR-5): porcentaje,
 *     por SUBTOTAL, rebaja todas las líneas.
 *
 * SE PIDEN LOS DOS Y NO SE COMPARAN. Es lo importante de este archivo: tienen
 * `combinesWith` en todo `false`, así que nunca suman, pero Shopify **deja
 * aplicable el que más rebaja** y marca el otro `applicable: false` — da igual
 * el orden en que se pidan — y **reevalúa solo en cada cambio del carrito**. Un
 * carrito que sube de ₴2.000 a ₴3.900 pasa del par al set sin que aquí pase
 * nada. Verificado de punta a punta el 2026-09-02; la tabla de casos está en
 * `rules/descuentos.md`, «Los dos códigos NO chocan».
 *
 * O sea: aquí no hay ningún comparador. Es la misma regla de siempre —el tema
 * no calcula rebajas— aplicada a cuál gana. El único código que este archivo
 * quita es el del set, y solo cuando el carrito deja de ser un set (más abajo,
 * «El código del set: dos condiciones»).
 *
 * POR QUÉ ESTO EXISTE
 *
 * En esta tienda cobra `ro.ro pay` (Chekly), no el checkout de Shopify. Chekly
 * recibe solo el token del carrito (`assets/chekly-script.js`) y lo lee por su
 * lado, así que:
 *
 *   - los descuentos AUTOMÁTICOS de Shopify NO llegan nunca. Comprobado con el
 *     pedido #1568: dentro de la ventana del `-5% на другий товар`, con dos
 *     artículos distintos, `totalDiscounts: 0` y los precios de línea intactos.
 *   - los descuentos por CÓDIGO SÍ llegan, porque el código se aplica al
 *     carrito y el carrito es justo lo que Chekly lee. Verificado de punta a
 *     punta el 30 ago 2026: carrito 148 800 → 133 920 y el checkout de Chekly
 *     mostrando la rebaja sin que nadie escribiera el código.
 *
 * De ahí este archivo: cuando el carrito llega al mínimo de artículos, pide
 * `/discount/<código>` en segundo plano. Shopify aplica el código al carrito y
 * a partir de ahí TODO el precio lo calcula Shopify — el tema no inventa ni un
 * número. `snippets/cart-products.liquid` ya pinta el precio tachado desde
 * `original_line_price` y el badge de ahorro desde
 * `line_level_discount_allocations`; los dos salen solos.
 *
 * Esa es la regla que no hay que romper: **el tema no calcula rebajas**. Si
 * algún día alguien dibuja aquí un precio "con oferta" a mano, vuelve el bug de
 * agosto de 2026 — la ficha prometiendo un precio que el checkout no cobra.
 *
 * EL CÓDIGO DEL SET: DOS CONDICIONES, Y UNA LA PONE ESTE ARCHIVO (2026-10-08)
 *
 * La founder no quiere el −5% en una pieza sola, por cara que sea: solo en un
 * set. Desde el 2026-10-08 `RORO-NABIR-5` exige las DOS cosas a la vez:
 *
 *   · `gift_pack_discount_min_items` piezas (2), sin contar tarjetas regalo.
 *     Dos unidades de la misma pieza cuentan, igual que en la ficha.
 *   · `gift_pack_discount_min` de subtotal (₴3.000), también sin tarjetas.
 *
 * Un descuento de Shopify solo admite UN mínimo (cantidad O subtotal), así que
 * el Admin lleva uno y este archivo el otro. Con el del Admin en «cantidad 2»
 * (el estado buscado: una pieza sola no lo coge ni tecleándolo en Chekly) los
 * ₴3.000 los pone solo el tema. Por eso aquí el código no solo se PIDE cuando
 * el carrito cumple: también se SUELTA en cuanto deja de cumplir. Un código
 * pegado a un carrito de dos piezas que baja de ₴3.000 seguiría rebajando, y
 * es justo lo que este archivo impide. Detalle y pruebas en
 * `rules/descuentos.md`, «Una pieza sola de ₴3.000+ sin −5%».
 *
 * Se suelta SOLO ese código: los demás que haya pegados (el welcome de
 * Klaviyo, que combina con este) se reenvían tal cual en el mismo
 * `/cart/update.js`, como hace `assets/cart-discount.js` al quitar una
 * pastilla. Y se mira también tras `discount:update`, el evento del campo de
 * código del carrito: quien lo teclee a mano con una pieza sola lo ve irse.
 *
 * Lo que este archivo no ve: el campo «Промокод» de Chekly, que escribe fuera
 * del carrito del tema. Ahí solo protege el mínimo del Admin.
 *
 * El código del par (`cart_bundle_discount_code`, hoy vacío) sigue como
 * siempre: lo decide su `minimumRequirement` y no se quita nunca.
 */
(function () {
  'use strict';

  var node = document.querySelector('script[data-roro-bundle-code]');
  if (!node) return;

  var CODE = (node.getAttribute('data-roro-bundle-code') || '').trim();
  var MIN = parseInt(node.getAttribute('data-roro-bundle-min'), 10);

  // El segundo código: el del set de `/pages/podarunky`. Su condición es de
  // SUBTOTAL y, desde el 2026-10-08, también de PIEZAS (las dos a la vez), así
  // que no comparte el `MIN` del par.
  var PACK_CODE = (node.getAttribute('data-roro-pack-code') || '').trim();
  var PACK_MIN = parseInt(node.getAttribute('data-roro-pack-min'), 10) || 0;
  // Piezas que hacen falta además del subtotal (`gift_pack_discount_min_items`).
  // Sin el atributo, 2: es la regla de la founder y la del Admin.
  var PACK_MIN_ITEMS = parseInt(node.getAttribute('data-roro-pack-min-items'), 10);
  if (!(PACK_MIN_ITEMS >= 1)) PACK_MIN_ITEMS = 2;
  // Sin código o sin subtotal configurado este archivo no gestiona el código
  // del set: ni lo pide ni lo suelta.
  var PACK_ON = !!PACK_CODE && PACK_MIN > 0;

  // Dos modos, y por defecto el prudente:
  //
  //   false -> este archivo NO aplica nada por su cuenta. Solo atiende el clic
  //            del aviso que pinta `snippets/cart-summary.liquid`. El cliente da
  //            un toque y ve lo que ha pasado.
  //   true  -> lo aplica en cuanto el carrito cumple, sin que nadie toque nada.
  //
  // Se enciende en el theme editor (`cart_bundle_auto_apply`), y solo despues de
  // haber probado el codigo de punta a punta contra el checkout real.
  var AUTO = node.getAttribute('data-roro-bundle-auto') === 'true';

  // Sin ningún código configurado la función entera está apagada. Es el estado
  // por defecto a propósito: los descuentos los crea Max en el Admin, y hasta
  // que no existan de verdad el tema no debe prometer nada.
  if (!CODE && !PACK_CODE) return;
  if (!MIN || MIN < 2) MIN = 2;

  var busy = false;

  // `shopify theme dev` (127.0.0.1 / localhost) no deja pasar `/discount/`:
  // responde 401, el código nunca se pega y el archivo lo reintentaba en cada
  // página, con un error rojo en la consola cada vez. En local no se pide; en el
  // dominio real (también con `preview_theme_id`) funciona igual que siempre.
  var DEV_HOST = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);
  var devNoticeShown = false;

  /**
   * Nunca lanza: si la respuesta no es JSON (429 de Shopify, pagina de error,
   * cuerpo vacio) devuelve `{}` en vez de reventar. Ver
   * `assets/roro-cart-fetch.js` — este archivo es de adorno, un fallo suyo no
   * puede tumbar el carrito.
   */
  function getJSON(url, options) {
    return fetch(url, options || { credentials: 'same-origin' }).then(
      function (r) {
        return window.RoroCart.json(r);
      },
      function () {
        return {};
      }
    );
  }

  function hasCode(cart, code) {
    var codes = (cart && cart.discount_codes) || [];
    var wanted = String(code || CODE).toUpperCase();
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code || '').toUpperCase() === wanted) return true;
    }
    return false;
  }

  /**
   * Qué códigos le faltan a ESTE carrito, en orden.
   *
   * NO se compara cuál rebaja más y aquí NO se quita ninguno (soltar el del set
   * cuando el carrito deja de ser un set es cosa de `packToDrop`): los dos se piden y
   * Shopify deja aplicable el que más ahorra, marcando el otro
   * `applicable: false`. Reevalúa solo en cada cambio del carrito, así que un
   * carrito que crece pasa del par al set sin que este archivo se entere.
   * Verificado en los dos órdenes el 2026-09-02 (`rules/descuentos.md`).
   *
   * Los umbrales de aquí solo deciden CUÁNDO se pide. Quien decide si aplica es
   * el `minimumRequirement` de cada descuento en el Admin, y los dos pares de
   * números tienen que decir lo mismo.
   */
  function missingCodes(cart) {
    if (!cart) return [];

    var out = [];

    // El par: condición de CANTIDAD.
    if (CODE && cart.item_count >= MIN && !hasCode(cart, CODE)) out.push(CODE);

    // El set: piezas Y subtotal (ver `packQualifies`).
    if (PACK_ON && packQualifies(cart) && !hasCode(cart, PACK_CODE)) out.push(PACK_CODE);

    return out;
  }

  /**
   * ¿Es este carrito un set con derecho al código? Piezas y subtotal, los dos.
   *
   * El subtotal es el de ANTES de descuentos, que es lo que mira Shopify: con
   * `total_price` el carrito bajaría del umbral justo por haberse aplicado el
   * descuento, y este archivo lo soltaría en bucle.
   *
   * Sin tarjetas regalo, ni en piezas ni en subtotal: Shopify no las rebaja ni
   * las cuenta para el mínimo (probado el 2026-10-06: certificado ₴2.500 + taza
   * ₴1.750 = ₴4.250 y el código no aplica). Es la misma cuenta que la escalera
   * del side cart (`snippets/roro-cart-shipping-bar.liquid`), el aviso de
   * `roro-cart-reward` y el panel de `roro-gift-pack-builder`: si se toca una,
   * las otras.
   *
   * Necesita las líneas (`/cart.js` entero): con un carrito sin `items` no
   * sabría restar las tarjetas regalo.
   *
   * @param {object} cart
   * @returns {boolean}
   */
  function packQualifies(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var subtotal = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
    var units = 0;
    cart.items.forEach(function (item) {
      if (item.gift_card) {
        subtotal -= item.original_line_price || 0;
      } else {
        units += item.quantity || 0;
      }
    });
    return units >= PACK_MIN_ITEMS && subtotal >= PACK_MIN;
  }

  /**
   * ¿Hay que soltar el código del set? Solo si está pegado y el carrito ya no
   * es un set de ₴3.000: una pieza sola, o dos que no llegan.
   *
   * @param {object} cart
   * @returns {boolean}
   */
  function packToDrop(cart) {
    return PACK_ON && Array.isArray(cart && cart.items) && hasCode(cart, PACK_CODE) && !packQualifies(cart);
  }

  /**
   * Suelta un código y deja los demás pegados.
   *
   * `/cart/update.js` con `discount` REEMPLAZA la lista entera de códigos del
   * carrito, así que se manda la de ahora sin este. Cadena vacía = ninguno. Es
   * lo mismo que hace `assets/cart-discount.js` al quitar una pastilla.
   *
   * Nunca rechaza: si falla, devuelve `null` y el carrito se queda como estaba.
   * El siguiente `cart:update` (o la siguiente página) lo vuelve a intentar.
   *
   * @param {object} cart
   * @param {string} code
   * @returns {Promise<object|null>}
   */
  function dropCode(cart, code) {
    var unwanted = String(code).toUpperCase();
    var keep = ((cart && cart.discount_codes) || [])
      .map(function (entry) {
        return String((entry && entry.code) || '');
      })
      .filter(function (value) {
        return value && value.toUpperCase() !== unwanted;
      });

    return window.RoroCart.post('/cart/update.js', { discount: keep.join(',') }).then(function (result) {
      var updated = result && result.ok && result.data && typeof result.data.item_count === 'number' ? result.data : null;
      // Aquí se repinta SIEMPRE: la rebaja (si la había) se va y el cajón tiene
      // que enseñar los precios sin ella.
      if (updated) notifyCart(updated);
      return updated;
    });
  }

  /**
   * Emite `cart:update` para que el cajón se repinte.
   *
   * Sin `sections`: `component-cart-items.js` se re-renderiza solo cuando el
   * evento no las trae (`sectionRenderer.renderSection`, ver el `else` de
   * `#handleCartUpdate`). Así no hay que pedir HTML a mano.
   *
   * `itemCount` ABSOLUTO y `source` propio, según el contrato de
   * `rules/liquid-patterns.md`: con `source: 'product-form-component'`
   * `<cart-icon>` SUMA en vez de asignar y el contador queda doblado.
   */
  function notifyCart(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || undefined,
          sourceId: 'roro-cart-bundle-discount',
          data: {
            source: 'roro-cart-bundle-discount',
            itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
            didError: false
          }
        }
      })
    );
  }

  /**
   * Pide el codigo y avisa si Shopify ha aplicado algo de verdad.
   *
   * Es el unico sitio del archivo que habla con `/discount/`. Los dos modos
   * —automatico y clic— pasan por aqui para que no se dupliquen las reglas.
   */
  function applyCode(code) {
    if (DEV_HOST) {
      if (!devNoticeShown) {
        devNoticeShown = true;
        console.info('[roro-cart-bundle-discount] En theme dev no se pega ' + code + ': /discount/ da 401 en local. Pruébalo en el dominio real.');
      }
      return Promise.resolve(null);
    }

    // `?redirect=/cart.js` no es un adorno: sin el, Shopify responde al
    // /discount/ con un 302 a la HOME, y `fetch` se descarga la pagina entera
    // antes de dejarnos seguir. Medido en el dominio real el 31 ago 2026, con
    // el mismo carrito:
    //
    //   por defecto            1 534 ms   1 268 891 bytes
    //   ?redirect=/cart.js       725 ms         4 668 bytes
    //
    // Y encima ahorra la peticion extra: el 302 termina justo en /cart.js, asi
    // que la respuesta YA es el carrito actualizado. Una peticion, no dos.
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return window.RoroCart.json(response);
      })
      .catch(function () {
        // Red de seguridad: si algun dia ese redirect deja de comportarse asi,
        // se pregunta por el carrito a la manera lenta en vez de romperse.
        return getJSON('/cart.js');
      })
      .then(function (updated) {
        // Solo se avisa si Shopify ha aplicado algo de verdad. Si el codigo ha
        // caducado, no cubre estos productos o el minimo no cuadra, no se
        // repinta nada y el carrito se queda como estaba — que es lo correcto:
        // no hay rebaja que ensenar.
        if (updated && updated.total_discount > 0) notifyCart(updated);
        return updated;
      });
  }

  /**
   * Modo manual: el boton del aviso del carrito.
   *
   * Delegado en `document` y no atado al nodo, porque la seccion del carrito se
   * re-renderiza entera en cada `cart:update` y cualquier listener puesto sobre
   * el boton moriria con el primer morphing.
   *
   * No hace falta quitar el aviso a mano: al aplicarse, `cart.total_discount`
   * deja de ser 0, la seccion se repinta y el bloque desaparece solo.
   */
  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-roro-pair-apply]') : null;
    if (!button || busy) return;

    event.preventDefault();
    busy = true;
    button.disabled = true;

    var cta = button.querySelector('[data-roro-pair-cta]');
    var label = cta ? cta.textContent : '';
    var waiting = cta ? cta.getAttribute('data-roro-pair-busy') : '';
    if (cta && waiting) cta.textContent = waiting;

    var code = (button.getAttribute('data-roro-pair-code') || CODE).trim();

    applyCode(code)
      .catch(function () {
        /* silencio: el carrito se queda a precio completo, que es lo seguro */
      })
      .then(function () {
        busy = false;
        // Si el aviso sigue en el DOM es que NO se aplico nada. Se devuelve el
        // boton a su estado para que se pueda reintentar.
        if (button.isConnected) {
          button.disabled = false;
          if (cta && label) cta.textContent = label;
        }
      });
  });

  // Un `cart:update` que llega con otra pasada en marcha no se tira: se apunta
  // y se repite al acabar. Antes se perdía, y con dos toques rápidos en «−» el
  // carrito podía quedarse con el código pegado sin ser ya un set.
  var again = false;

  function sync() {
    // El propio `notifyCart` dispara otra vez los listeners. El corte real es
    // que en la segunda vuelta ya no falta ni sobra ningún código, pero el
    // cerrojo evita las peticiones cruzadas mientras tanto.
    if (busy) {
      again = true;
      return;
    }
    busy = true;

    getJSON('/cart.js')
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return null;

        // Primero se suelta lo que sobra, siempre, también en modo manual: es
        // lo que impide que una pieza sola, o un set por debajo de ₴3.000, se
        // lleve el −5%. Después, con el carrito ya limpio, se pide lo que falta.
        var ready = packToDrop(cart) ? dropCode(cart, PACK_CODE) : Promise.resolve(cart);

        return ready.then(function (current) {
          if (!AUTO || !current) return null;
          var pending = missingCodes(current);
          if (!pending.length) return null;

          // En serie, no en paralelo: son dos escrituras sobre el mismo carrito y
          // lanzadas a la vez la segunda puede leer el estado de antes de la
          // primera. Son como mucho dos peticiones, y solo la primera vez que el
          // carrito cruza cada umbral.
          return pending.reduce(function (chain, code) {
            return chain.then(function () {
              return applyCode(code);
            });
          }, Promise.resolve());
        });
      })
      .catch(function () {
        // Silencio a propósito: si falla la red, el carrito se queda como
        // estaba y el siguiente `cart:update` lo vuelve a intentar.
      })
      .then(function () {
        busy = false;
        if (again) {
          again = false;
          sync();
        }
      });
  }

  // Sin modo automático tampoco se piden códigos solos, pero el código del set
  // se sigue soltando cuando el carrito deja de ser un set: eso no es una
  // comodidad, es lo que mantiene la regla de la founder.
  if (!AUTO && !PACK_ON) return;

  function onCartChange(event) {
    // No reaccionar al evento que emite este mismo archivo.
    var detail = event && event.detail && event.detail.data;
    if (detail && detail.source === 'roro-cart-bundle-discount') return;
    sync();
  }

  document.addEventListener('cart:update', onCartChange);
  // El campo de código del carrito (`assets/cart-discount.js`) no emite
  // `cart:update`, emite este. Sin escucharlo, quien teclease el código con una
  // pieza sola se lo quedaba hasta el siguiente cambio del carrito.
  document.addEventListener('discount:update', onCartChange);

  // Y al cargar: el carrito puede venir de una visita anterior (con dos piezas
  // y sin código, o con el código y ya sin ser un set) sin que se dispare
  // ningún `cart:update`.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
